export default __webpack_public_path__ + "static/hmpg-video-placeholder-v2-fa11f055d98c2e67ac5b3b45a3bf1d17.jpg";